import { Form, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { useBnsMeiJieListQuery } from '../../store/ReactWebSiteApi';

function MediaForm(props) {
    const [list, setList] = useState();
    const {data, isSuccess} = useBnsMeiJieListQuery({bmj_e_id:localStorage.getItem('e_id')},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bmj_id:key,bmj_name} = item;
                    return item = {value:key,label:bmj_name}
                })                
               
                setList(newArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    return (
        <Form.Item
            label='媒介'
            name={props.name}
            wrapperCol={props.wrapperCol}
            required={props.required}                            
        >
            <Select
                options={list}
                onChange={(e,f) => {props.onChange(e,f)}}
                showSearch
                optionFilterProp="label"
            />
        </Form.Item>
    )
}

export default MediaForm